__webpack_require__.p = "https://monitor-web.quid.com/cb/web/";